import { render, staticRenderFns } from "./InnerStage.vue?vue&type=template&id=3f315133&"
import script from "./InnerStage.vue?vue&type=script&lang=js&"
export * from "./InnerStage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports